const initialState: BlockState = {
  activeBlock: '',
  previousBlock: '',
  cookieAgreement: false,
};

export default initialState;
